import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { forTablet, forDesktop } from '@westwing/ui-kit/breakPoints';
import StyledSlider from '../StyledSlider';
import AppliedFilterItem from './AppliedFilterItem';

const AppliedFilterStyledSlider = styled(StyledSlider)`
    padding-left: 0;

    ${forTablet`
        padding: 0;
    `}
`;

const AppliedFilterStyledSliderWrapper = styled.div<{ hide: boolean }>`
    display: ${({ hide }) => (hide ? 'none' : 'block')};
    overflow-y: hidden;
    margin: 9px auto 7px;

    ${forDesktop`
        height: auto;
        margin-top: auto;
        margin-bottom: 15px;
    `}
`;

export interface AppliedSliderFilter {
    filter: string;
    name: string;
    value: string;
}

interface Props {
    filters: AppliedSliderFilter[];
    removeFilterFunc: (filter: string, value: string) => void;
}

const AppliedFiltersSlider: FC<Props> = ({ filters, removeFilterFunc }): ReactElement => {
    return (
        <div>
            <AppliedFilterStyledSliderWrapper hide={filters.length === 0}>
                <AppliedFilterStyledSlider>
                    {filters.map(({ filter, value, name }) => (
                        <AppliedFilterItem
                            name={name}
                            key={value}
                            removeFilterFunc={() => removeFilterFunc(filter, value)}
                        />
                    ))}
                </AppliedFilterStyledSlider>
            </AppliedFilterStyledSliderWrapper>
        </div>
    );
};

export default AppliedFiltersSlider;
